/**
 * Rev2.1 — shared utility data_source normalization (mirrors python/energy_format_utility_sources.py).
 */

function collapseDataSourceLabel(dataSource: string): string {
  return (dataSource || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
}

export function isCecEnergyDataSource(dataSource: string): boolean {
  if (!dataSource?.trim()) return false;
  const c = collapseDataSourceLabel(dataSource);
  return c === 'cec' || c.includes('californiaenergycommission');
}

export function isNrelEnergyDataSource(dataSource: string): boolean {
  return /nrel/i.test(dataSource || '');
}

/** Direct IOU / SoCalGas / EIA-861 utility observation (tier 55 when measurement=observed + activity). */
export function isDirectUtilityObservedDataSource(
  dataSource: string,
  measurement?: string | null
): boolean {
  if (!dataSource?.trim()) return false;
  if (measurement != null && String(measurement).toLowerCase().trim() !== 'observed') return false;
  if (isCecEnergyDataSource(dataSource)) return false;
  if (isNrelEnergyDataSource(dataSource)) return false;

  const raw = dataSource.trim();
  const c = collapseDataSourceLabel(raw);
  const u = raw.toUpperCase();

  if (c === 'pge' || c.startsWith('pge') || c.includes('pacificgas') || u.includes('PACIFIC GAS')) return true;
  if (c === 'sce' || c.includes('southerncaliforniaedison') || /\bSCE\b/.test(u)) return true;
  if (
    c.includes('socalgas') ||
    c.includes('southerncaliforniagas') ||
    c === 'scg' ||
    c.endsWith('scg') ||
    u.replace(/\s/g, '').includes('SOCALGAS') ||
    u.includes('SOUTHERN CALIFORNIA GAS')
  ) {
    return true;
  }
  if (c.includes('sdge') || c.includes('sandiegogas') || raw.includes('SDG&E') || u.includes('SDGE')) return true;
  if (c.includes('eia861') || raw.toLowerCase().includes('eia-861') || u.includes('EIA-861')) return true;

  const municipalMarkers = [
    'ladwp',
    'losangelesdepartmentofwaterandpower',
    'burbankwaterandpower',
    'burbankwaterpower',
    'bwp',
    'sacramentomunicipal',
    'smud',
    'pasadenawaterandpower',
    'pwp',
    'glendalewaterandpower',
    'gwp',
    'riversidepublicutilities',
    'rpu',
    'imperialirrigationdistrict',
    'iid',
  ];
  if (municipalMarkers.some((m) => c.includes(m))) return true;

  return false;
}
